import axios from '../../utils/axios';

export const getVideo = async (id) => {
    const response = axios.get(`/videos/${id}`);

    return (await response).data;
};

export const patchLikeVideo = async (id) => {
    const currentVideo = await getVideo(id);
    const response = await axios.patch(`/videos/${id}`, { likes: currentVideo.likes + 1 });
    return response.data;
};

export const patchUnlikeVideo = async (id) => {
    const currentVideo = await getVideo(id);
    const response = await axios.patch(`/videos/${id}`, { unlikes: currentVideo.unlikes + 1 });
    return response.data;
};
